<ngb-toast *ngFor="let toast of _commonService.toasts" [class]="toast.className" [autohide]="true" [delay]="toast.delay"
    (hidden)="_commonService.removeToast(toast)" [header]="toast.header??''" [animation]="toast.animation??true">
    {{ toast.body }}
</ngb-toast>